import { OnInit } from '@angular/core';
var ConfidentialityComponent = /** @class */ (function () {
    function ConfidentialityComponent() {
    }
    ConfidentialityComponent.prototype.ngOnInit = function () {
    };
    return ConfidentialityComponent;
}());
export { ConfidentialityComponent };
